<mat-sidenav-container class="submissiontree-container">
  <mat-sidenav position="end" mode="over" class="field-editor-sidebar" #editPanel mat-component-id="editPanel">
    <!--<div *ngIf="parentNode && parentNode.type === 'root'">-->
    <aw-add-submission-type (formClosed)="closeForm($event)">
    </aw-add-submission-type>
  <!--</div>-->
</mat-sidenav>
<mat-sidenav-content>
  @if (treeData) {
    <div>
      <aw-tree [treeData]="treeData" (deleteNode)="deleteNode($event)" (addNode)="addChildNode($event)"></aw-tree>
    </div>
  }
</mat-sidenav-content>
</mat-sidenav-container>